import React from 'react';

const dialogContext = React.createContext({
  closeDialog: null,
});

export default dialogContext;
